export default __webpack_public_path__ + "static/media/1st edition book cover.153e41cf.png";